<template>
	<div id="vx-col w-full mb-base" ref="popupContainer">
		<vs-popup
			:active.sync="showFilterPopup"
			:title="`Rapport sélectionné: ${reportName}`"
		>
			<h2 style="padding-left: 15px; padding-bottom: 2px">Filtres</h2>
			<ReportFilterMission v-if="isfilterMission" @close-popup="closePopup" />
			<div
				v-else
				class="vx-row w-full mb-3 mt-2"
				style="align-items: center; padding-left: 28px"
			>
				Du
				<vx-input-group class="datepicker-1 vx-col">
					<flat-pickr
						id="flatpickr"
						v-model="startDate"
						:config="configDatePicker"
						style="width: 100px; text-align: center"
						@input="userSelected(1)"
					/>
				</vx-input-group>
				au
				<vx-input-group class="datepicker-2 vx-col">
					<flat-pickr
						id="flatpickr"
						v-model="endDate"
						:config="configDatePicker"
						style="width: 100px; text-align: center"
						@input="userSelected(1)"
						doUpdateValue="false"
					/>
				</vx-input-group>
				<div v-on:click="enablePeriod()" class="period-div">
					<flat-pickr
						id="periodpicker"
						class="periodpicker mr-5"
						v-model="periodPicker"
						placeholder="Période"
						:config="configPeriodPicker"
						style="width: 100px; text-align: center"
						@input="userSelected(2)"
						@keydown.native.delete.capture.stop.prevent
					/>
				</div>
				<vs-input
					class="mr-5"
					placeholder="N°CONTRAT"
					v-model="contractIdFilter"
					@input="userSelected(3)"
				/>
				<vs-select
					class="mr-5"
					autocomplete
					v-model="soceityFilter"
					@change="userSelected(4)"
				>
					<vs-select-item :value="null" text="CLIENT" />
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in listSoceityName"
					/>
				</vs-select>

				<div
					class="vx-row w-full"
					style="align-items: center; padding-left: 28px"
				>
					<vs-button class="mt-2 w-full" @click="generate(reportId)"
						>Confirmer</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<vs-popup
			:active.sync="showDetailPopup"
			:title="`Détail du rapport: ${reportName}`"
		>
			<h2 style="padding-left: 15px; padding-bottom: 2px">
				Statut: {{ reportStatus == 1 ? "En cours de génération" : "Généré" }}
			</h2>
			<div
				class="vx-row w-full"
				style="align-items: center; padding-left: 28px"
			>
				Filtre: Du {{ reportStartDate.split("-").reverse().join("/") }} au
				{{ reportEndDate.split("-").reverse().join("/") }}
			</div>
		</vs-popup>

		<vx-card class="mt-1" style="max-height: 69vh; overflow: auto">
			<h3>Liste des rapports disponibles</h3>
			<vs-table
				max-items="10"
				stripe
				:data="reports"
				style="margin-top: 15px"
				:key="refreshData"
			>
				<template slot="thead">
					<vs-th class="th-sticky">Nom du rapport</vs-th>
					<vs-th class="th-sticky pdl0"
						><div class="w-full text-center">TÉLÉCHARGER</div></vs-th
					>
					<vs-th class="th-sticky pdl0">Détails filtres</vs-th>
					<vs-th class="th-sticky pdl0">Générer</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="index" v-for="(tr, index) in data">
						<vs-td>{{ tr.name }}</vs-td>
						<vs-td class="text-center pdl0">
							<vs-button
								v-if="tr.path && tr.path.length > 0 && tr.executing == 0"
								color="success"
								style="border-radius: 50px"
								@click="download(tr.id)"
								>{{ tr.fin_date }}
								<feather-icon
									icon="DownloadIcon"
									style="
										margin-top: -6px;
										width: 15px;
										height: 1px;
										vertical-align: middle;
									"
								/>
							</vs-button>
							<vs-button
								v-else-if="tr.executing == 1"
								color="warning"
								style="border-radius: 50px"
								>En cours
								<feather-icon
									icon="ClockIcon"
									style="
										margin-top: -3px;
										width: 15px;
										height: 1px;
										vertical-align: middle;
									"
								/>
							</vs-button>
							<span v-else>Aucun rapport</span>
						</vs-td>
						<vs-td
							class="text-center pdl0"
							style="padding-left: 36px !important"
						>
							<vs-button
								size="large"
								type="transparent"
								icon-pack="feather"
								icon="icon-list"
								style="color: black"
								@click="displayDetailPopup(tr)"
							></vs-button>
						</vs-td>
						<vs-td
							class="text-center pdl0"
							style="padding-left: 15px !important"
						>
							<vs-button
								size="large"
								type="transparent"
								icon-pack="feather"
								icon="icon-refresh-cw"
								style="color: black"
								@click="displayFilterPopup(tr.id, tr.name)"
							></vs-button>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";
import VueCookies from "vue-cookies";
import ReportFilterMission from "../filters/ReportFilterMission.vue";
import flatPickr from "vue-flatpickr-component";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import Society from "@/entities/Society.js";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import XLSX from "xlsx";

export default {
	components: {
		VxCard,
		flatPickr,
		ReportFilterMission,
	},
	name: "ReportsDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			configDatePicker: {
				dateFormat: "d/m/Y",
			},
			isfilterMission: false,
			periodDisable: true,
			endDate: new Date()
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/"),
			refreshData: 0,
			reportEndDate: "0000-00-00",
			reportName: null,
			reportId: null,
			reportStartDate: "0000-00-00",
			reportStatus: null,
			showDetailPopup: false,
			showFilterPopup: false,
			startDate:
				"01/" +
				new Date()
					.toISOString()
					.substring(0, 10)
					.split("-")
					.reverse()
					.join("/")
					.substring(3, 10),

			periodPicker: moment().format("MM/YYYY"),
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			listContractId: [
				{ contract_id: 45, id: 0 },
				{ contract_id: 46, id: 1 },
				{ contract_id: 47, id: 2 },
				{ contract_id: 48, id: 3 },
			],
			contractIdFilter: null,
			soceityFilter: null,
			isPeriodPicked: false,
			isSocietyPicked: false,
			isContractPicked: false,
			isDatePicked: true,
			reportType: 0,

			listSoceityName: [],
		};
	},
	created() {
		this.$store.dispatch("getAllReports");

		Society.getAllSocities((err, res) => {
			if (res) {
				this.listSoceityName = res.data;
			}
		});
	},
	mounted() {
		document.querySelector(".periodpicker").style.backgroundColor = "#D3D3D3";
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		reports: () => {
			return store.state.reports;
		},
	},
	watch: {},

	methods: {
		closePopup() {
			//console.log("CLOSING");
			this.showFilterPopup = false;
		},
		deselectAll(usid) {
			let ids = [1, 2, 3, 4];
			//console.log("rapport filter", usid);
			if (usid == 1) {
				document.querySelector(
					".datepicker-1 .vx-input-group-default .flatpickr-input"
				).style.backgroundColor = "#FFFFFF";
				document.querySelector(
					".datepicker-2 .vx-input-group-default .flatpickr-input"
				).style.backgroundColor = "#FFFFFF";
			}
			if (usid == 2)
				document.querySelector(
					".period-div .periodpicker"
				).style.backgroundColor = "#FFFFFF";
			ids.forEach((id) => {
				if (id != usid) {
					if (id == 1) {
						document.querySelector(
							".datepicker-1 .vx-input-group-default .flatpickr-input"
						).style.backgroundColor = "#D3D3D3";
						document.querySelector(
							".datepicker-2 .vx-input-group-default .flatpickr-input"
						).style.backgroundColor = "#D3D3D3";
						this.isDatePicked = false;
					}
					if (id == 2) {
						document.getElementById("periodpicker").value = "12/2022";
						document.querySelector(
							".period-div .periodpicker"
						).style.backgroundColor = "#D3D3D3";
						this.periodPicker = false;
					}
				}
			});
		},
		userSelected(id) {
			if (id == 1) {
				this.reportType = id;
				this.isDatePicked = true;
				this.periodDisable = true;
				this.deselectAll(id);
			} else if (id == 2) {
				if (!this.periodDisable) {
					this.reportType = id;
					this.isPeriodPicked = true;
					this.deselectAll(id);
				}
			}
			/*
			 * else if(id==3){
			 * 	this.reportType = id;
			 * 	this.isContractPicked = true;
			 * 	this.periodDisable = true;
			 * 	this.deselectAll(id);
			 * }
			 * else if(id ==4){
			 * 	this.reportType = id;
			 * 	this.isSocietyPicked = true;
			 * 	this.periodDisable = true;
			 * 	this.deselectAll(id);
			 */

			// }
		},
		enablePeriod() {
			this.periodDisable = false;
		},
		/**
		 * Show details popup
		 * @function displayDetailPopup
		 * @param {object} report - information of the selected report
		 */
		displayDetailPopup(report) {
			this.reportName = null;
			this.reportId = null;
			this.reportStatus = null;
			this.reportStartDate = null;
			this.reportEndDate = null;
			this.reportName = report.name;
			this.reportId = report.id;
			this.reportStatus = report.executing;
			this.reportStartDate = report.start_date;
			this.reportEndDate = report.end_date;
			this.showDetailPopup = true;
		},

		/**
		 * Show filters popup
		 * @function displayFilterPopup
		 * @param {number} id - id of the selected report
		 * @param {string} name - name of the selected report
		 */
		displayFilterPopup(id, name) {
			this.reportName = null;
			this.reportId = null;
			this.reportName = name;
			this.reportId = id;
			this.isfilterMission = id == 4 ? true : false;
			this.showFilterPopup = true;
		},

		/**
		 * Download selected report
		 * @function download
		 * @param {number} id - id of the selected report
		 */
		download(id) {
			let report = this.reports.find((r) => r.id == id);
			let name = report.name;
			if (report) {
				this.$http
					.post(this.apiUrl + "report/download", {
						path: this.reports.find((r) => r.id == id).path,
					})
					.then((file) => {
						// console.log(file.data);
						const data = new Blob([file.data]);
						const reader = new FileReader();

						reader.onload = (event) => {
							const data = new Uint8Array(event.target.result);
							// Convert Uint8Array to binary string
							const binaryString = String.fromCharCode.apply(null, data);
							const workbook = XLSX.read(binaryString, { type: "binary" });
							const xlsxData = XLSX.utils.sheet_to_json(
								workbook.Sheets[workbook.SheetNames[0]],
								{ header: 1 }
							);
							const worksheet = XLSX.utils.aoa_to_sheet(xlsxData, {
								cellDates: true,
							});
							const newWorkbook = XLSX.utils.book_new();
							XLSX.utils.book_append_sheet(newWorkbook, worksheet, "Sheet1");
							const excelBuffer = XLSX.write(newWorkbook, {
								bookType: "xlsx",
								type: "array",
							});
							const excelBlob = new Blob([excelBuffer], {
								type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
							});
							const downloadLink = document.createElement("a");
							downloadLink.href = URL.createObjectURL(excelBlob);
							downloadLink.download = name + ".xlsx";
							downloadLink.click();
						};

						reader.readAsArrayBuffer(data);
					});
			}
		},

		/**
		 * Generate report
		 * @function generate
		 * @param {number} id - id of the selected report
		 */
		generate(id) {
			let request;
			switch (id) {
				case 1:
					request = "report/invoicingService";
					break;
				case 2:
					request = "report/contractLifespan";
					break;
				case 3:
					request = "report/contractRentability";
					break;
				default:
					this.$vs.notify({
						title: "Erreur",
						text: "ID Rapport n'existe pas.",
					});
					return;
			}
			this.showFilterPopup = false;

			let report = this.reports.find((r) => r.id == id);
			if (report) {
				this.reports[this.reports.indexOf(report)].executing = 1;
				this.reports[this.reports.indexOf(report)].start_date = this.startDate;
				this.reports[this.reports.indexOf(report)].end_date = this.endDate;
			}
			this.refreshData++;
			let sdate, edate;
			if (this.isPeriodPicked) {
				let splitDate = this.periodPicker.split("/");
				let date = splitDate[0].toString() + "-01-" + splitDate[1];
				let monthDate = moment(date);

				sdate = monthDate.startOf("month").format("YYYY-MM-DD");
				edate = monthDate.endOf("month").format("YYYY-MM-DD");
				this.reportType = 1;
			}
			if (this.isDatePicked) {
				edate = !this.endDate
					? ""
					: this.endDate.split("/").reverse().join("-");
				sdate = !this.startDate
					? ""
					: this.startDate.split("/").reverse().join("-");
				this.reportType = 1;
			}
			this.$http.post(this.apiUrl + request, {
				end_date: this.isDatePicked || this.isPeriodPicked ? edate : null,
				report_id: id,
				start_date: this.isDatePicked || this.isPeriodPicked ? sdate : null,
				contract_id: this.contractIdFilter,
				period: this.isPeriodPicked ? this.periodPicker : null,
				society: this.soceityFilter,
				user_id: this.activeUser.id,
				user_email: this.activeUser.email,
				report_type: this.reportType,
			});
		},
	},
};
</script>

<style>
.center {
	justify-content: center;
}
</style>
